import { render, staticRenderFns } from "./SubscriptionChanged.vue?vue&type=template&id=487d8255&"
import script from "./SubscriptionChanged.vue?vue&type=script&lang=js&"
export * from "./SubscriptionChanged.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports